<template>
  <Portlet
    :title="$t('notesView.notes')"
    icon="history"
  >
    <div class="historyComments">
      <LoadingPlaceholder v-if="loading" />
      <Grid
        v-else
        :ref="kgm_ref"
        :style="{height: 'auto'}"
        :data-items="dataItems"
        :columns="kgm_responsiveColumns()"
        :filterable="true"
        :filter="kgm_filter"
        :pageable="kgm_pagable"
        :page-size="kgm_take"
        :skip="kgm_skip"
        :take="kgm_take"
        :total="total"
        :sortable="{
          allowUnsort: true,
          mode: kgm_sortMode
        }"
        :sort="kgm_sort"
        selected-field="selected"
        @rowclick="kgm_gridOnRowClick"
        @filterchange="onFilterChange"
        @pagechange="onPageChange"
        @sortchange="onSortChange"
      >
        <template
          slot="nameLink"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <router-link
              :to="`/installation/${ props.dataItem.installationId }`"
              class="alt-primary-color"
              target="_blank"
            >
              <span>{{ kgm_getNestedValue(props.field, props.dataItem) }}</span>
            </router-link>
          </td>
        </template>

        <template
          slot="dateTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            {{ dateTime_dateTime(props.dataItem.lastCreateDate) }}
          </td>
        </template>

        <div
          slot="nameFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="nameFilterInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a name"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('nameFilterInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <div
          slot="lastUserNameFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="userFilterInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a user name"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('userFilterInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <div
          slot="lastCreateDateFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="lastCreateDateInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a date"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('lastCreateDateInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <div
          slot="amoutOfDayFromLastMessageFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="amoutOfDayFromLastMessageInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a number"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('amoutOfDayFromLastMessageInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <div
          slot="amoutOfSevenDaysMessagesFilter"
          slot-scope="{props, methods}"
          class="input-group"
        >
          <input
            ref="amoutOfSevenDaysMessagesInput"
            :value="props.value"
            type="text"
            class="form-control mr-2 rounded-right"
            placeholder="please enter a number"
            @input="(event) => {methods.change({operator: 'contains', field: props.field, value: event.target.value, syntheticEvent: event});}"
          >
          <div
            v-if="props.value"
            class="input-group-append"
          >
            <button
              class="btn btn-light border rounded"
              @click="kgm_resetInput('amoutOfSevenDaysMessagesInput', (event) => {methods.change({operator: '', field: '', value: '', syntheticEvent: event});})"
            >
              <font-awesome-icon
                class="gray"
                icon="times"
              />
            </button>
          </div>
        </div>

        <template
          slot="optionsTemplate"
          slot-scope="{props}"
        >
          <td :class="props.className">
            <div class="btn-group">
              <button
                class="btn btn-primary btn-sm"
                @click="openNotesModal(props.dataItem)"
              >
                <span class="hide-down-sm">{{ $t('notesView.moreNotes') }}</span>
                <span class="hide-up-sm">All</span>
              </button>
              <button
                class="btn btn-success btn-sm"
                @click="addNote(props.dataItem.installationId)"
              >
                <font-awesome-icon
                  class="mr-2"
                  icon="plus"
                />
                <span class="hide-down-sm">Create</span>
              </button>
            </div>
          </td>
        </template>
      </Grid>

      <SweetModal
        ref="moreNotes"
        :title="$t('notesView.notes')"
        blocking
        class="overflowHidden"
      >
        <template v-if="selectedNote">
          <LoadingPlaceholder v-if="modalLoading" />

          <div
            v-else
            style="overflow: auto; max-height: 500px;"
          >
            <table class="table">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="hide-down-sm"
                  >
                    Type
                  </th>
                  <th scope="col">
                    Date
                  </th>
                  <th scope="col">
                    Recipient
                  </th>
                  <th
                    scope="col"
                    class="hide-down-sm"
                  >
                    From
                  </th>
                  <th scope="col">
                    Note
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in selectedNoteComments"
                  :key="`id-listItem-${ index }`"
                >
                  <td class="hide-down-sm">
                    {{ item.type }}
                  </td>
                  <td>
                    {{ dateTime_dateTime(item.created) }}
                  </td>
                  <td>
                    {{ item.recipient }}
                  </td>
                  <td class="hide-down-sm">
                    {{ item.userName }}
                  </td>
                  <td>
                    <span v-html="changeMessage(item.message)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <button
          slot="button"
          class="btn btn-secondary float-right mb-3"
          @click="$refs.moreNotes.close()"
        >
          <font-awesome-icon
            class="mr-2"
            icon="times"
          />{{ $t('cancel') }}
        </button>
        <div class="clearfix" />
      </SweetModal>
    </div>
  </Portlet>
</template>

<script>
import { kendoGridMixin } from '@/mixins/kendoGridMixin.js'
import { dateTimeMixin } from '@/mixins/dateTimeMixin.js'
import { SweetModal } from 'sweet-modal-vue'

export default {
	name: 'HistoryComments',
	components: {
		SweetModal,
	},
	mixins: [
		dateTimeMixin,
		kendoGridMixin,
	],
	data () {
		return {
			loading: true,
			dataItems: [],
			total: 0,

			selectedNote: null,
			selectedNoteComments: [],
			modalLoading: false,

			kgm_columns: [
				{
					field: 'installationName',
					filterable: true,
					filter: 'text',
					title: 'Name',
					cell: 'nameLink',
					filterCell: 'nameFilter',
				},
				{
					field: 'lastCreateDate',
					filterable: true,
					filter: 'text',
					title: this.$t('notesView.noteCreateDate'),
					filterCell: 'lastCreateDateFilter',
					cell: 'dateTemplate',
				},
				{
					field: 'lastUserName',
					filterable: true,
					filter: 'text',
					title: this.$t('notesView.lastUser'),
					hideOn: ['smDown'],
					filterCell: 'lastUserNameFilter',
				},
				{
					field: 'amoutOfDayFromLastMessage',
					filterable: true,
					filter: 'text',
					title: this.$t('notesView.amoutLastDayMessage'),
					hideOn: ['xlDown'],
					filterCell: 'amoutOfDayFromLastMessageFilter',
				},
				{
					field: 'amoutOfSevenDaysMessages',
					filterable: true,
					filter: 'text',
					title: this.$t('notesView.amoutSevenDayMessage'),
					hideOn: ['xlDown'],
					filterCell: 'amoutOfSevenDaysMessagesFilter',
				},
				{
					filterable: false,
					cell: 'optionsTemplate',
				},
			],
		}
	},
	created () {
		this.refresh()
	},
	methods: {
		refresh () {
			return this.fetchPage()
		},
		changeMessage (message) {
			return message ? message.replace(/\n/g, '<br>').replaceAll(';', '<br>') : ''
		},
		addNote (id) {
			this.$emit('showNoteAdd', id)
		},

		onSortChange (event) {
			this.kgm_gridSortChange(event)
			this.fetchPage()
		},
		onPageChange (event) {
			this.kgm_gridPageChange(event)
			this.fetchPage()
		},
		onFilterChange (event) {
			this.kgm_gridFilterChange(event)
			this.kgm_skip = 0
			this.fetchPage()
		},

		extractFilters () {
			const result = {}

			const f = this.kgm_filter && this.kgm_filter.filters ? this.kgm_filter.filters : []
			for (const item of f) {
				if (!item || !item.field) continue
				if (item.value === undefined || item.value === null || item.value === '') continue

				if (item.field === 'installationName') result.filterInstallationName = item.value
				if (item.field === 'lastUserName') result.filterLastUserName = item.value
				if (item.field === 'lastCreateDate') result.filterLastCreateDateContains = item.value
				if (item.field === 'amoutOfDayFromLastMessage') result.filterDayCountContains = item.value
				if (item.field === 'amoutOfSevenDaysMessages') result.filterSevenDaysContains = item.value
			}

			return result
		},

		async fetchPage () {
			this.loading = true

			const sort = this.kgm_sort && this.kgm_sort.length ? this.kgm_sort[0] : null
			const sortField = sort ? sort.field : null
			const sortDir = sort ? sort.dir : null

			const params = {
				skip: this.kgm_skip,
				take: this.kgm_take,
				sortField,
				sortDir,
				...this.extractFilters(),
			}

			try {
				const response = await this.axios.get('/Installation/GetGroupedInstallationCommentsSummary', { params })
				const data = response && response.data ? response.data : null

				this.dataItems = data && data.items ? data.items : []
				this.total = data && data.total ? data.total : 0
			} finally {
				this.loading = false
			}
		},

		async openNotesModal (note) {
			this.selectedNote = note
			this.selectedNoteComments = []
			this.modalLoading = true
			this.$refs.moreNotes.open()

			try {
				const response = await this.axios.get('/Installation/GetInstallationComments', {
					params: { installationId: note.installationId, take: 10 },
				})
				this.selectedNoteComments = response && response.data ? response.data : []
			} finally {
				this.modalLoading = false
			}
		},
	},
}
</script>

<style>
.historyComments .k-grid table tr:hover td {
	background: rgb(219, 219, 219) !important;
	cursor: pointer !important;
}
</style>
